import { useState } from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

export default function QuickStartSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('curl -fsSL https://openclaw.ai/install.sh | bash');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-cyan-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="fadeUp" className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 border border-cyan-500/30">
            <i className="ri-terminal-line"></i>
            <span className="text-sm font-semibold">Quick Start</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            一行命令，快速开始
          </h2>
          <p className="text-base sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            支持 macOS、Windows 与 Linux。一行命令即可自动安装 Node.js 及其它所有依赖
          </p>
        </AnimatedSection>

        <AnimatedSection animation="scale" delay={200}>
          <div className="bg-slate-800/80 backdrop-blur-xl rounded-2xl border border-cyan-500/30 overflow-hidden shadow-2xl shadow-cyan-500/20">
            <div className="bg-slate-900/50 px-4 sm:px-6 py-3 sm:py-4 border-b border-slate-700 flex items-center justify-between">
              <div className="flex items-center gap-1.5 sm:gap-2">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-500"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-yellow-500"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-500"></div>
              </div>
              <span className="text-gray-400 text-xs sm:text-sm font-mono">Terminal</span>
              <button
                onClick={handleCopy}
                className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-cyan-500/10 hover:bg-cyan-500/20 text-cyan-400 rounded-lg transition-all cursor-pointer text-xs sm:text-sm border border-cyan-500/30"
              >
                <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
                <span>{copied ? '已复制' : '复制'}</span>
              </button>
            </div>
            
            <div className="p-5 sm:p-8 overflow-x-auto">
              <div className="flex items-start gap-3 sm:gap-4 min-w-0">
                <span className="text-cyan-400 font-mono text-base sm:text-lg flex-shrink-0">$</span>
                <code className="text-white font-mono text-sm sm:text-lg leading-relaxed whitespace-nowrap">
                  curl -fsSL https://openclaw.ai/install.sh | bash
                </code>
              </div>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection animation="fadeUp" delay={400}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
            {[
              { icon: 'ri-download-cloud-line', title: '自动安装依赖', desc: '自动检测并安装 Node.js 等必需组件' },
              { icon: 'ri-settings-3-line', title: '智能配置', desc: '引导式配置，5分钟完成初始化' },
              { icon: 'ri-rocket-line', title: '即刻启动', desc: '安装完成后立即可用，无需额外配置' },
            ].map((item) => (
              <div 
                key={item.title}
                className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-slate-700 hover:border-cyan-500/50 transition-all duration-500 hover:shadow-lg hover:shadow-cyan-500/20"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center mb-3 sm:mb-4 shadow-lg shadow-cyan-500/30">
                  <i className={`${item.icon} text-xl sm:text-2xl text-white`}></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-1.5 sm:mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}